import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormInputErrorComponent} from './form-input-error.component';
import {SharedModule} from '../../../modules/shared/shared.module';

@NgModule({
  declarations: [
    FormInputErrorComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    FormInputErrorComponent
  ]
})
export class FormInputErrorModule {
}
